import Vue from 'vue'

import vuelidate from 'vuelidate'

Vue.use(vuelidate)
